const GA_ID = process.env.REACT_APP_GA4_ID;
const KEY = "sanaa-consent";

export const analyticsConfigured = Boolean(GA_ID);
export const getConsent = () => (typeof window === "undefined" ? null : window.localStorage.getItem(KEY));

export function setConsent(value) {
  window.localStorage.setItem(KEY, value);
  if (value === "granted") loadGa();
}

export function loadGa() {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

// Événements : cta_click, phone_click, whatsapp_click, booking_click, form_submit…
export function track(event, params = {}) {
  if (window.gtag && getConsent() === "granted") window.gtag("event", event, params);
}
